import script from "./PatientVisitServicesSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientVisitServicesSummary.vue?vue&type=script&setup=true&lang=js"

import "./PatientVisitServicesSummary.vue?vue&type=style&index=0&id=02a2248b&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a2248b"]])

export default __exports__